((Drupal) => {
  "use strict";

  // Handle logic for showing or hiding icons in the "assignment image"
  // upload area based on the presence of an input field.
  const assignmentImageInputLogic = (context) => {
    const targetNode = context.querySelector("#assignment-image-item");
    if (!targetNode) return;

    const inputFile = targetNode.querySelector(
      '[id^="edit-assignment-image-upload"]'
    );

    // Toggles the visibility of icons based on the presence of an input field.
    const toggleIcons = () => {
      targetNode.classList.toggle("show-icons", Boolean(inputFile));
    };

    toggleIcons();

    // Observe changes in the targetNode and update icon visibility accordingly.
    const observer = new MutationObserver(() => toggleIcons());
    observer.observe(targetNode, { childList: true, subtree: true });
  };

  Drupal.behaviors.assignmentImageInputLogic = {
    attach(context) {
      assignmentImageInputLogic(context);
    },
  };
})(Drupal);
